import { InputColumnConfig } from "../../../components/common/table_input/tableInput";

export interface InputConfig {
    title: string;
    columns: InputColumnConfig[];
}

export const NAME_CORRECTION_TYPES = [
    { value: 'producer', label: 'Producer' },
    { value: 'lease', label: 'Lease' },
    { value: 'destination', label: 'Destination' },
];

export const getNameCorrectionsConfig = (
    producerOptions: any[],
    leaseOptions: any[],
    destinationOptions: any[],
    nameCorrectionsValues: Record<string, any>
): InputConfig => {
    const selectedType = nameCorrectionsValues.type;

    const baseColumns: InputColumnConfig[] = [
        {
            colName: 'type',
            placeholder: 'Type',
            colType: 'text',
            required: true,
            inputType: 'dropdown',
            dropdownOptions: NAME_CORRECTION_TYPES
        }
    ];

    // Dynamic fields based on type selection
    if (selectedType === 'producer') {
        // For producer type: show producer_id dropdown
        baseColumns.push({
            colName: 'producer_id',
            placeholder: 'Producer',
            colType: 'number',
            required: true,
            inputType: 'dropdown',
            dropdownOptions: producerOptions,
        });
    } else if (selectedType === 'lease') {
        // For lease type: show producer_id dropdown first
        baseColumns.push({
            colName: 'producer_id',
            placeholder: 'Producer',
            colType: 'number',
            required: true,
            submitValue: false, // Don't submit producer_id to table, it's for filtering
            inputType: 'dropdown',
            dropdownOptions: producerOptions,
            linkedGroup: ['lease_id'],
            getLinkedFilteredOptions: (g: Record<string, any>, allProducers: any[]) => {
                if (g.lease_id) {
                    const selectedLease = leaseOptions.find(lease => Number(lease.value) === Number(g.lease_id));
                    if (selectedLease?.producer_id)
                        return allProducers.filter(producer => Number(producer.value) === Number(selectedLease.producer_id));
                }
                return allProducers;
            }
        });

        // Show lease_id dropdown filtered by producer
        baseColumns.push({
            colName: 'lease_id',
            placeholder: 'Lease',
            colType: 'number',
            required: true,
            inputType: 'dropdown',
            dropdownOptions: leaseOptions,
            linkedGroup: ['producer_id'],
            getLinkedFilteredOptions: (g: Record<string, any>, allLeases: any[]) => {
                if (g.producer_id)
                    return allLeases.filter(lease => Number(lease.producer_id) === Number(g.producer_id));
                return allLeases;
            }
        });
    } else if (selectedType === 'destination') {
        baseColumns.push({
            colName: 'station_id',
            placeholder: 'Destination',
            colType: 'number',
            required: true,
            inputType: 'dropdown',
            dropdownOptions: destinationOptions,
            dependsOn: 'type',
            getFilteredOptions: () => destinationOptions
        });
    }

    // Always add variations field at the end
    if (selectedType) {
        baseColumns.push({
            colName: 'variations',
            placeholder: 'Variations',
            colType: 'text',
            required: true
        });
    }

    return {
        title: 'Name Corrections',
        columns: baseColumns
    };
};